"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const theme_1 = require("../../../theme");
const lineHeight = 24;
const maxHeight = 168;
class TextInput extends react_1.default.Component {
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return { height: lineHeight };
    }
    constructor(props) {
        super(props);
        this.state = {
            height: lineHeight,
        };
    }
    render() {
        return (react_1.default.createElement(react_native_1.TextInput, { editable: !this.props.disabled, multiline: true, value: this.props.value, placeholder: this.props.placeholder, onChangeText: this.props.onChangeText, style: [
                styles.input,
                { height: this.state.height },
                this.props.customStyles,
            ], onSelectionChange: ({ nativeEvent }) => { var _a, _b; return (_b = (_a = this.props).onSelectionChange) === null || _b === void 0 ? void 0 : _b.call(_a, nativeEvent.selection.start, nativeEvent.selection.end); }, onContentSizeChange: ({ nativeEvent: { contentSize: { height: newHeight }, }, }) => {
                if (Math.abs(this.state.height - newHeight) === 2) {
                    if (this.state.height < newHeight) {
                        this.setState({
                            height: Math.min(maxHeight, Math.max(lineHeight, this.state.height + lineHeight)),
                        });
                    }
                    else {
                        this.setState({
                            height: Math.min(maxHeight, Math.max(lineHeight, this.state.height - lineHeight)),
                        });
                    }
                }
                else {
                    this.setState({
                        height: Math.min(maxHeight, Math.max(lineHeight, newHeight)),
                    });
                }
            } }));
    }
}
exports.TextInput = TextInput;
// Note: The input somehow needs the border as the behavior is different otherwise ¯_(ツ)_/¯
const styles = react_native_1.StyleSheet.create({
    input: {
        borderColor: 'transparent',
        borderWidth: 1,
        fontFamily: theme_1.fontFamilyAlternate,
        fontSize: 17,
        lineHeight,
        padding: 8,
    },
});
